import { Route } from 'react-router-dom';

import { BusinessProfilePage } from './BusinessProfilePage.js';

/** The authenticated, tabbed Business Profile inside the merchant shell. */
export function businessProfileRoutes() {
  return <Route path="/business-profile/:tab" element={<BusinessProfilePage />} />;
}
